import { render, staticRenderFns } from "./Trems.vue?vue&type=template&id=63086380&scoped=true&"
import script from "./Trems.vue?vue&type=script&lang=js&"
export * from "./Trems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63086380",
  null
  
)

export default component.exports